import { gql, useQuery } from '@apollo/client';

const GET_ORG_SALESFORCE_NAME = gql`
  query GetOrgSalesforceName($salesforceAccountId: String!) {                                                                                                   
    getOrgSalesforceName(salesforceAccountId: $salesforceAccountId)                                                                                             
  }    
`;

export default GET_ORG_SALESFORCE_NAME;